// This a dialog is used to adjust a community member's wallet.  It shows a
// textfield that the user can adjust to make the necessary adjustment.
import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import "date-fns";
import CommunityMemberTransaction from "../../../functions/Firestore/Wallet/CommunityMemberTransaction.js";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";

export default function AdjustMemberWallet({
  communityWallets,
  index,
  setCommunityWallets,
}) {
  const [open, setOpen] = useState(false);
  const [transactionAmount, setTransactionAmount] = useState(0);
  const [depositNotes, setDepositNotes] = useState("");
  const [paymentMethod, setPaymentMethod] = useState("misc");

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setPaymentMethod("");
  };
  const handlePaymentMethodChange = (value) => {
    setPaymentMethod(value);
    setTransactionAmount(0);
  };
  // Ensure the amount entered is either negative or positive depending on the method of payment the
  // user has selected.
  const enforceAmount = (raw) => {
    const val = Number(raw);
    if (paymentMethod === "refund") {
      return -Math.abs(val);
    }
    if (paymentMethod === "mileage" || paymentMethod === "packaging") {
      return Math.abs(val);
    }
    return val;
  };

  // When the user saves their changes then this calls the functions to save to
  // the database.
  const handleSave = async (e) => {
    e.preventDefault();
    const communityWalletsTemp = communityWallets;
    const updatedWallet = await CommunityMemberTransaction(
      transactionAmount,
      { ...communityWallets[index] },
      depositNotes,
      null,
      paymentMethod,
    );
    communityWalletsTemp[index] = updatedWallet;
    setCommunityWallets([...communityWalletsTemp]);
    setOpen(false);
    setDepositNotes("");
    setTransactionAmount(0);
    setPaymentMethod("");
  };

  return (
    <div>
      <Button size="small" color="primary" onClick={handleClickOpen}>
        ADJUST WALLET
      </Button>
      <Dialog
        onClose={handleClose}
        aria-labelledby="simple-dialog-title"
        open={open}
      >
        <DialogTitle id="simple-dialog-title">
          ADD OR SUBTRACT AMOUNTS TO THE MEMBER'S WALLET
        </DialogTitle>
        <DialogContent>
          {/* Reset the value of the donationSubsidy to 0 when the user
            changes to the subsidy radioButton.  This is to prevent mistakenly
            going into the negative if the value is bigger than what is owed */}
          <RadioGroup
            name="paymentMethod"
            value={paymentMethod}
            onChange={(e) => handlePaymentMethodChange(e.target.value)}
          >
            <FormControlLabel
              value="refund"
              control={<Radio />}
              label="Refund"
            />
            <FormControlLabel
              value="mileage"
              control={<Radio />}
              label="Mileage"
            />
            <FormControlLabel
              value="packaging"
              control={<Radio />}
              label="Packaging Bought"
            />
            <FormControlLabel
              value="misc"
              control={<Radio />}
              label="Miscellaneous"
            />
          </RadioGroup>

          <span
            style={{ display: "flex", alignItems: "center", marginTop: 10 }}
          >
            <p style={{ marginRight: 4 }}>$</p>
            <TextField
              label="Amount"
              type="number"
              placeholder={
                paymentMethod === "refund"
                  ? "Enter refund (will be negative)"
                  : paymentMethod === "mileage" || paymentMethod === "packaging"
                  ? "Enter amount (will be positive)"
                  : "Enter amount (+ or -)"
              }
              value={transactionAmount}
              onChange={(e) =>
                setTransactionAmount(enforceAmount(e.target.value))
              }
            />
          </span>

          <TextField
            label="Notes"
            fullWidth
            multiline
            minRows={4}
            variant="outlined"
            value={depositNotes}
            onChange={(e) => setDepositNotes(e.target.value)}
            style={{ marginTop: 15 }}
          />

          <DialogActions>
            <Button color="primary" onClick={handleClose}>
              Cancel
            </Button>
            {transactionAmount !== 0 && (
              <Button color="primary" onClick={handleSave}>
                Save
              </Button>
            )}
          </DialogActions>
        </DialogContent>
      </Dialog>
    </div>
  );
}
